<template>
  <div class="product-center">
    <main class="product-center-main">
      <img loading="lazy" class="main-bg" src="@/assets/img/productCenter/1.png" alt="">
      <div class="main-research-domain" ref="mainResearchDomain">
        <div class="title">{{ '主要研究领域' }}</div>
        <div class="product-container">
          <div v-for="item in domainList" :key="item.id" class="domain-item">
            <div class="item">
              <img loading="lazy" class="item-icon" src="@/assets/img/productCenter/2.png" height="21px" alt="">
              <span class="product-name">{{ item.productName }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="main-product" ref="mainProduct">
        <div class="title">{{ '主要产品' }}</div>
        <div class="product-container">
          <div v-for="item in productList" :key="item.id" class="product-item"
            @click="$router.push({ name: '/productDetails', params: item })" @mouseenter="item.showDetail = true"
            @mouseleave="item.showDetail = false">
            <div class="item">
              <img loading="lazy" class="item-icon" src="@/assets/img/productCenter/3.png" alt="">
              <span class="product-name">{{ item.productName }}</span>
            </div>
            <Transition enter-active-class="animate__fadeIn" leave-active-class="animate__fadeOut">
              <div v-if="item.showDetail" class="product-description animate__animated">
                {{ item.description }}
              </div>
            </Transition>

          </div>
        </div>
      </div>
    </main>
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/footer/index'
export default {
  name: '',
  components: {
    Footer,
  },
  props: [],
  data() {
    return {
      domainList: [],
      productList: [],
      showDetail: false,
    }
  },
  created() {
    this.getProductData()

  },

  methods: {
    getProductData() {
      this.$apis.product_center_list().then(res => {
        this.domainList = res.data.filter(item => item.category == '主要研究领域')
        this.productList = res.data.filter(item => item.category == '主要产品')
        this.productList.forEach(item => {
          this.$set(item, 'showDetail', false)
        })
      })
    },
  },
}
</script>

<!-- 私有 -->

<style lang='scss' scoped>
.product-center {
  display: flex;
  flex-direction: column;
  min-height: 100%;

  .product-center-main {
    flex: 1;
    display: flex;
    flex-direction: column;


    .main-research-domain {
      .product-container {
        grid-template-columns: repeat(4, 1fr);
        row-gap: 2.5rem;

        @media screen and (max-width : 400px) {
          grid-template-columns: repeat(3, 1fr);
        }
      }
    }

    .main-product {
      flex: 1;
      margin-top: 3.125rem;
      background: #F0F9FF;
      padding-bottom: 1.875rem;

      .product-container {
        grid-template-columns: repeat(3, 1fr);
        gap: 43.2px;

        @media screen and (max-width : 400px) {
          grid-template-columns: repeat(2, 1fr);
        }

        .product-item {
          height: 8.75rem;
          cursor: pointer;

          &:hover .product-name {
            text-decoration: underline;
          }

          .product-description {
            box-sizing: border-box;
            display: -webkit-box;
            background: #D9EFFC;
            font-weight: 400;
            border-radius: 12px;
            padding: 10px 20px 4px 20px;
            margin-top: 10px;
            font-size: 16px;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
          }
        }
      }
    }
  }

  .footer {
    margin-top: 20px;
  }


}
</style>

<!-- 共有 -->

<style lang='scss' scoped>
.product-center {
  .product-center-main {

    .main-research-domain,
    .main-product {
      display: grid;
      justify-content: center;
      text-align: left;
      grid-template-rows: 5.625rem 1fr;

      .title {
        font-family: FZLanTingHei-H-GBK;
        font-weight: 600;
        font-size: 1.75rem;
        color: #81B1D7;
        font-style: italic;
        text-align: left;
        margin-top: 1.25rem;
        height: 2.3125rem;
      }

      .product-container {
        width: 81.25rem;
        min-width: 81.25rem;
        display: grid;
        font-family: FZLanTingHei-H-GBK;
        font-weight: 600;
        font-size: 16px;
        color: #1A1A1A;
        margin-left: 120px;

        .domain-item,
        .product-item {


          .item {
            display: flex;
            align-items: center;

            .item-icon {
              width: 1.125rem;
              height: 1.125rem;
            }
          }

          .product-name {
            margin-left: 10px;
            font-size: 20px;
            overflow: hidden;
            /*超出部分隐藏*/
            white-space: nowrap;
            /*禁止换行*/
            text-overflow: ellipsis;
            /*省略号*/
          }
        }
      }
    }
  }
}
</style>